"use client"

import {
  Carousel,
  CarouselContent,
  CarouselItem
} from "@/components/ui/carousel"
import type { BannerDTO } from "@/domain/cms/contracts"

import { BannerCard } from "./BannerCard"
import { PromoDots } from "./PromoDots"
import { MOBILE_BANNER_SIZES } from "./slides"

export function PromoMobile({ banners }: { banners: BannerDTO[] }) {
  const leadUrl = banners[0]
    ? (banners[0].mobileImageUrl ?? banners[0].imageUrl)
    : null

  return (
    <Carousel className="w-full" opts={{ align: "center" }}>
      <CarouselContent className="-ml-2.5">
        {banners.map((banner, index) => {
          const imageUrl = banner.mobileImageUrl ?? banner.imageUrl

          return (
            <CarouselItem key={banner.id} className="basis-full pl-2.5">
              <BannerCard
                banner={banner}
                featured
                mobile
                priority={index === 0}
                loading={imageUrl === leadUrl ? "eager" : "lazy"}
                sizes={MOBILE_BANNER_SIZES}
              />
            </CarouselItem>
          )
        })}
      </CarouselContent>
      <PromoDots count={banners.length} />
    </Carousel>
  )
}
